import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "editable-element",
    ref: "elementRef",
    id: `editable-element-${_ctx.elementInfo.id}`,
    style: {
      zIndex: _ctx.elementIndex,
      fontFamily: _ctx.theme.fontName,
    }
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentElementComponent), {
      elementInfo: _ctx.elementInfo,
      selectElement: _ctx.selectElement,
      contextmenus: _ctx.elementInfo.videoSource ? _ctx.youji : _ctx.contextmenus  
    }, null, 8, ["elementInfo", "selectElement", "contextmenus"]))
  ], 12, ["id"]))
}